import React, { useState } from "react";
import { useParams } from "react-router-dom";
import EditCustomerModal from "../component/editcustomermodel/EditCustomerModal";
import EditCountryRateModal from "../component/editcustomermodel/EditCountryRateModal";
import MakeReseller from "../component/editcustomermodel/MakeReseller";
import EditTMDetail from "../component/editcustomermodel/EditTMDetail";
import SettingsIcon from "@mui/icons-material/Settings";

import {
  Button,
  Typography,
  TableContainer,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  List,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  ListItem,
  Box,
  Grid,
  Tooltip,
  IconButton,
  Paper,
} from "@mui/material";
import { toast } from "react-toastify";
import {
  useGetResellerIntroQuery,
  useCheckResellerStatusQuery,
  useGetCustomerCountryDataQuery,
  useCreateCustomerCountryRatesMutation,
  useUpdateResellerIntroMutation,
  useUpdateCountryRatesMutation,
  useUpdateCustomerBalanceMutation,
  useGetResellerCustomerSettingsQuery,
  useUpdateResellerCustomerSettingsMutation,
} from "../store/services/resellerApi";
import { useGetCustomerServicesQuery } from "../store/services/flowApi";
import {
  useGetPhoneNUmberQuery,
  useLazyGetPhoneNUmberQuery,
  useUpdateWhatsappConfigMutation,
} from "../store/services/whatsappApi";
import { useGetAllBotsListQuery } from "../store/services/rcstemplateApi";
import { iconButtonStyle } from "../component/common/Encryption";
import { useGetCustomerLogDeleteKeyQuery } from "../store/services/reportApi";

const ProfileDetail = () => {
  const { customer_id } = useParams();
  const [selectedCountryData, setSelectedCountryData] = useState(null);
  const [openSettingsDialog, setOpenSettingsDialog] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [balanceModalOpen, setBalanceModalOpen] = useState(false);
  const [balance, setBalance] = useState("");
  const [balanceError, setBalanceError] = useState("");
  const [selectedServiceId, setSelectedServiceId] = useState(null);
  const [resellerRates, setResellerRates] = useState({});
  const { data: serviceData } = useGetCustomerServicesQuery(customer_id, {
    skip: !customer_id,
  });
  const [updateWhatsappConfig] = useUpdateWhatsappConfigMutation();

  const selectedService = serviceData?.data?.find(
    (s) => s.service_id === Number(selectedServiceId),
  );

  const isWhatsAppSelected = selectedService?.service_name === "WhatsApp";

  const {
    data: phoneData,
    error: phoneError,
    isError: isPhoneError,
    isFetching: isPhoneFetching,
    refetch: refetchPhoneNumber,
  } = useGetPhoneNUmberQuery(customer_id, {
    skip: !isWhatsAppSelected || !customer_id,
  });

  const {
    data: featureKeyData,
    isLoading: featureLoading,
    refetch: refetchFeatureKeys,
  } = useGetCustomerLogDeleteKeyQuery();

  const [updateCustomerSettings] = useUpdateResellerCustomerSettingsMutation();
  // const safeParameters = featureKeyData?.data || {};
  const {
    data: rcsBotsData,
    isFetching: isRcsBotsFetching,
    isError: isRcsBotsError,
  } = useGetAllBotsListQuery(customer_id, {
    skip: !customer_id,
  });

  const { data: customerSettingsData, refetch: refetchCustomerSettings } =
    useGetResellerCustomerSettingsQuery(customer_id, {
      skip: !customer_id,
    });

  const safeParameters = customerSettingsData?.data || {};
  // const [updateCustomerSettings] = useUpdateResellerCustomerSettingsMutation();
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [balanceSummary, setBalanceSummary] = useState("");
  const [makeResellerModalOpen, setMakeResellerModalOpen] = useState(false);
  const [selectedCustomerData, setSelectedCustomerData] = useState(null);
  const [editTMDetailModalOpen, setEditTMDetailModalOpen] = useState(false);
  const [countryRatesModalOpen, setCountryRatesModalOpen] = useState(false);
  const [filteredCountries, setFilteredCountries] = useState([]);

  const [updatedDetails, setUpdatedDetails] = useState({
    username: "",
    customer_name: "",
    customer_add1: "",
    customer_add2: "",
    city: "",
    state: "",
    pin: "",
    aadhar: "",
    showreportcount: "",
    customer_email: "",
    customer_mobile: "",
    is_active: true,
  });

  const {
    data: customerData,
    isLoading: customerLoading,
    error: customerError,
    refetch: refetchCustomerData,
  } = useGetResellerIntroQuery(customer_id);
  console.log({ customerData });

  const {
    data: resellerStatus,
    isLoading: statusLoading,
    error: statusError,
  } = useCheckResellerStatusQuery(customer_id);

  const {
    data: countryData,
    isLoading: countryLoading,
    error: countryError,
    refetch: refetchCountryData,
  } = useGetCustomerCountryDataQuery(customer_id);

  const [createCountryRates] = useCreateCustomerCountryRatesMutation();
  const [updateResellerIntro] = useUpdateResellerIntroMutation();
  const [updateCountryRates] = useUpdateCountryRatesMutation();
  const [updateCustomerBalance] = useUpdateCustomerBalanceMutation();
  const countryDropdown = countryData?.data?.countryCustomerData || [];
  const resellerCountries = countryData?.data?.countryResellerData || [];
  const isReseller = resellerStatus?.data;
  const isLoading = customerLoading || statusLoading || countryLoading;
  const error = customerError || statusError || countryError;

  const handleOpenEditTMDetailModal = (customerData) => {
    if (!customerData?.customer_id) {
      console.error(
        "Error: Customer ID is missing in customerData",
        customerData,
      );
      toast.error("Customer ID is missing. Cannot proceed.");
      return;
    }
    setSelectedCustomerData(customerData);
    setEditTMDetailModalOpen(true);
  };

  const handleCloseEditTMDetailModal = () => {
    setSelectedCustomerData(null);
    setEditTMDetailModalOpen(false);
  };

  const handleOpenMakeResellerModal = (customerData) => {
    setSelectedCustomerData({ ...customerData, customer_id });
    setMakeResellerModalOpen(true);
  };

  const handleCloseMakeResellerModal = () => {
    setSelectedCustomerData(null);
    setMakeResellerModalOpen(false);
  };

  const handleCreateNewCountry = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setSelectedCountryData(null);
    setIsModalOpen(false);
  };

  const handleServiceChange = (e) => {
    const serviceId = Number(e.target.value);
    setSelectedServiceId(serviceId);

    const filtered = resellerCountries.filter(
      (c) => c.service_id === serviceId,
    );

    setFilteredCountries(filtered);
  };

  const handleCountrySelectForNewCountry = (e) => {
    const countryId = Number(e.target.value);

    const selectedCountry = resellerCountries.find(
      (c) =>
        c.country_id === countryId &&
        c.service_id === Number(selectedServiceId),
    );

    if (!selectedCountry) return;

    setSelectedCountryData(selectedCountry);

    if (selectedService?.service_name === "SMS") {
      setResellerRates({
        dlt_rates: selectedCountry.dlt_rates,
        sms_rates: selectedCountry.sms_rates,
      });
    }

    if (selectedService?.service_name === "WhatsApp") {
      setResellerRates({
        authentication_price: selectedCountry.authentication_price,
        marketing_price: selectedCountry.marketing_price,
        utility_price: selectedCountry.utility_price,
      });
    }

    if (selectedService?.service_name === "RCS") {
      setResellerRates({
        rcs_media_rate: selectedCountry.rcs_media_rate,
        rcs_text_rate: selectedCountry.rcs_text_rate,
      });
    }
  };

  const handleSubmitNewCountry = async (e) => {
    e.preventDefault();

    if (!selectedCountryData || !selectedService) {
      toast.error("Please select service and country");
      return;
    }

    const form = e.target;
    const payload = {
      customer_id,
      country_id: selectedCountryData.country_id,
      service_id: selectedServiceId,
    };

    /* ================= SMS ================= */
    if (selectedService.service_name === "SMS") {
      const dlt_rates = Number(form.dlt_rates.value);
      const sms_rates = Number(form.sms_rates.value);

      if (dlt_rates < resellerRates.dlt_rates) {
        toast.error(`DLT Rates must be ≥ ${resellerRates.dlt_rates}`);
        return;
      }

      if (sms_rates < resellerRates.sms_rates) {
        toast.error(`SMS Rates must be ≥ ${resellerRates.sms_rates}`);
        return;
      }

      payload.dlt_rates = dlt_rates;
      payload.sms_rates = sms_rates;
    }

    /* ================= RCS ================= */
    /* ================= RCS ================= */
    if (selectedService.service_name === "RCS") {
      if (
        !rcsBotsData ||
        !Array.isArray(rcsBotsData.data) ||
        rcsBotsData.data.length === 0
      ) {
        toast.error(
          "Please first assign bot to this customer and then add the rates",
        );
        return;
      }

      const rcs_media_rate = Number(form.rcs_media_rate.value);
      const rcs_text_rate = Number(form.rcs_text_rate.value);

      if (rcs_media_rate < resellerRates.rcs_media_rate) {
        toast.error(`RCS Media Rate must be ≥ ${resellerRates.rcs_media_rate}`);
        return;
      }

      if (rcs_text_rate < resellerRates.rcs_text_rate) {
        toast.error(`RCS Text Rate must be ≥ ${resellerRates.rcs_text_rate}`);
        return;
      }

      payload.rcs_media_rate = rcs_media_rate;
      payload.rcs_text_rate = rcs_text_rate;
    }

    if (selectedService.service_name === "WhatsApp") {
      if (isPhoneFetching) {
        toast.info("Verifying WhatsApp configuration...");
        return;
      }

      if (isPhoneError) {
        const errorCode =
          phoneError?.data?.code || phoneError?.error || phoneError?.status;

        if (phoneError?.status === 404 || errorCode === "CUSTOMER_NOT_FOUND") {
          toast.error(
            "Please first add the WhatsApp configuration and then add WhatsApp rates",
          );
          return;
        }

        toast.error(
          phoneError?.data?.message ||
            "Failed to verify WhatsApp configuration",
        );
        return;
      }

      // ✅ CONFIG EXISTS — continue
      const authentication_price = Number(form.auth_rate.value);
      const marketing_price = Number(form.marketing_rate.value);
      const utility_price = Number(form.utility_rate.value);

      if (authentication_price < resellerRates.authentication_price) {
        toast.error(
          `Auth rate must be ≥ ${resellerRates.authentication_price}`,
        );
        return;
      }

      if (marketing_price < resellerRates.marketing_price) {
        toast.error(
          `Marketing rate must be ≥ ${resellerRates.marketing_price}`,
        );
        return;
      }

      if (utility_price < resellerRates.utility_price) {
        toast.error(`Utility rate must be ≥ ${resellerRates.utility_price}`);
        return;
      }

      payload.authentication_price = authentication_price;
      payload.marketing_price = marketing_price;
      payload.utility_price = utility_price;
    }

    try {
      // 1️⃣ Create country rates (COMMON)
      await createCountryRates(payload).unwrap();

      // 2️⃣ EXTRA STEP — ONLY FOR WHATSAPP ✅
      if (selectedService.service_name === "WhatsApp") {
        const whatsappPayload = {
          customer_id: Number(customer_id),
          price: {
            AUTHENTICATION: payload.authentication_price,
            MARKETING: payload.marketing_price,
            UTILITY: payload.utility_price,
          },
        };

        await updateWhatsappConfig(whatsappPayload).unwrap();
      }

      toast.success("Country rates created successfully");
      setIsModalOpen(false);
      refetchCountryData();
    } catch (err) {
      toast.error(err?.data?.message || "Error creating country rates");
    }
  };

  const handleEditClick = (customer) => {
    setEditingCustomer(customer);
    setUpdatedDetails({
      username: customer.username || "",
      customer_name: customer.customer_profile?.customer_name || "",
      customer_add1: customer.customer_profile?.customer_add1 || "",
      customer_add2: customer.customer_profile?.customer_add2 || "",
      city: customer.customer_profile?.city || "",
      state: customer.customer_profile?.state || "",
      pin: customer.customer_profile?.pin || "",
      aadhar: customer.customer_profile?.aadhar || "",
      showreportcount: customer.customer_profile?.showreportcount || "",
      customer_email: customer.customer_profile?.customer_email || "",
      customer_mobile: customer.customer_profile?.customer_mobile || "",
      is_active: customer.is_active,
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateResellerIntro({
        customer_id: editingCustomer.customer_id,
        ...updatedDetails,
      }).unwrap();

      toast.success("Customer details updated successfully");
      setEditingCustomer(null);
      refetchCustomerData();
    } catch (err) {
      toast.error(err.data?.message || "Error updating customer details");
    }
  };

  const handleEditCountryRates = (country) => {
    setSelectedCountryData({
      ...country,
      service: country.service, // 🔥 VERY IMPORTANT
    });
    setCountryRatesModalOpen(true);
  };

  const handleCountryRateSubmit = async (updatedData) => {
    try {
      const payload = {
        customer_country_id: updatedData.customer_country_id,
        show_service: updatedData.show_service,
      };

      /* ================= SMS ================= */
      if (updatedData.service?.service_name === "SMS") {
        payload.dlt_rates = Number(updatedData.dlt_rates);
        payload.sms_rates = Number(updatedData.sms_rates);
      }

      /* ================= RCS ================= */
      if (updatedData.service?.service_name === "RCS") {
        payload.rcs_media_rate = Number(updatedData.rcs_media_rate);
        payload.rcs_text_rate = Number(updatedData.rcs_text_rate);
      }

      /* ================= WhatsApp ================= */
      if (updatedData.service?.service_name === "WhatsApp") {
        payload.authentication_price = Number(updatedData.authentication_price);
        payload.marketing_price = Number(updatedData.marketing_price);
        payload.utility_price = Number(updatedData.utility_price);
      }

      await updateCountryRates(payload).unwrap();

      if (updatedData.service?.service_name === "WhatsApp") {
        const whatsappPayload = {
          customer_id: Number(customer_id),
          price: {
            AUTHENTICATION: payload.authentication_price,
            MARKETING: payload.marketing_price,
            UTILITY: payload.utility_price,
          },
        };

        await updateWhatsappConfig(whatsappPayload).unwrap();
      }

      toast.success("Country data updated successfully");
      setCountryRatesModalOpen(false);
      refetchCountryData();
    } catch (err) {
      toast.error(err.data?.message || "Error updating country rates");
    }
  };

  const handleUpdateBalance = async (e) => {
    if (!balance || Number(balance) === 0) {
      setBalanceError("Please enter a valid balance amount.");
      return;
    }
    e.preventDefault();

    try {
      await updateCustomerBalance({
        customer_id,
        balance,
        summary: balanceSummary,
      }).unwrap();
      toast.success("Balance updated successfully!");
      setBalanceModalOpen(false);
      setBalance("");
      setBalanceSummary("");
      refetchCustomerData();
      setBalanceError("");
    } catch (err) {
      toast.error(err.data?.message || "Error updating balance");
    }
  };

  const handleBalanceModalClose = () => {
    setBalanceModalOpen(false);
    setBalance("");
  };

  const handleCloseModal = () => {
    setEditingCustomer(null);
    setSelectedCountryData(null);
    setCountryRatesModalOpen(false);
  };
  const handleToggle = async (field) => {
    try {
      const newValue = !safeParameters?.[field];

      await updateCustomerSettings({
        customer_id,
        [field]: newValue,
      }).unwrap();

      toast.success("Setting updated successfully");

      refetchCustomerSettings();
    } catch (err) {
      toast.error(err?.data?.message || "Failed to update setting");
    }
  };
  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
        }}
      >
        <img src="/ZZ5H.gif" alt="Loading..." width="150" />
        <Typography variant="h6" style={{ marginTop: 20 }}>
          please wait...
        </Typography>
      </div>
    );
  }
  const getColumnData = (labels, values) => {
    return (
      <Table size="small">
        <TableBody>
          {labels.map((label, index) => (
            <TableRow key={index}>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: 600 }}>
                {label}
              </TableCell>
              <TableCell sx={{ fontSize: "0.8rem" }}>{values[index]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  };
  const resellerFeatureKeys = featureKeyData?.data || {};

  const settingsList = [
    { key: "show_report_count", label: "Show Report Count" },
    { key: "show_mobile_number", label: "Show Mobile Number" },
    { key: "isfailed_refund", label: "Allow Failed Refund" },
  ];

  const rows = settingsList
    .filter((item) => resellerFeatureKeys?.[item.key] === true)
    .map((item) => ({
      label: item.label,
      value: (
        <Button
          size="small"
          variant="contained"
          color={safeParameters?.[item.key] ? "success" : "error"}
          onClick={() => handleToggle(item.key)}
          sx={{ fontSize: "0.7rem", minWidth: 70 }}
        >
          {safeParameters?.[item.key] ? "TRUE" : "FALSE"}
        </Button>
      ),
    }));
  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <div className="flex flex-1">
        <main className="flex-1 p-6">
          {/* Action Buttons Card */}
          <Box
            sx={{
              width: "100%",
              borderRadius: "8px",
              boxShadow: 2,
              p: 1,
              bgcolor: "white",
              mb: 2,
            }}
          >
            <div className="grid grid-cols-2 gap-8">
              {/* Profile Actions */}
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ height: 30, fontSize: "0.7rem" }}
                  onClick={() => {
                    console.log(
                      "Edit button clicked. Customer Data:",
                      customerData?.data?.customerViewDetails,
                    );
                    handleEditClick(customerData?.data?.customerViewDetails);
                  }}
                >
                  Edit Customer
                </Button>
              </Box>

              {/* Country Actions */}
              <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ height: 30, fontSize: "0.7rem" }}
                  onClick={() => setBalanceModalOpen(true)}
                >
                  Add Balance
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  sx={{ height: 30, fontSize: "0.7rem" }}
                  onClick={handleCreateNewCountry}
                >
                  Add Service Rates
                </Button>

                <Tooltip title="Settings">
                  <IconButton
                    sx={{ ...iconButtonStyle, ml: "auto" }}
                    onClick={() => setOpenSettingsDialog(true)}
                  >
                    <SettingsIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
            </div>
          </Box>

          {/* Cards Row */}
          <div className="grid grid-cols-2 gap-8">
            {/* Profile Details Card */}
            <Box
              sx={{
                width: "100%",
                borderRadius: "8px",
                boxShadow: 2,
                p: 1,
                bgcolor: "white",
              }}
            >
              <Typography
                variant="h6"
                color="primary"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              >
                Profile Details
              </Typography>
              {customerData?.data?.customerViewDetails && (
                <TableContainer
                  component={Box}
                  sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}
                >
                  <Table sx={{ fontSize: "0.7rem" }}>
                    <TableBody>
                      {Object.entries({
                        Username:
                          customerData.data.customerViewDetails.username,
                        "Customer Name":
                          customerData.data.customerViewDetails.customer_profile
                            ?.customer_name,
                        Email:
                          customerData.data.customerViewDetails.customer_profile
                            ?.customer_email,
                        Mobile:
                          customerData.data.customerViewDetails.customer_profile
                            ?.customer_mobile,
                        Address: `${customerData.data.customerViewDetails.customer_profile?.customer_add1 || ""}, ${customerData.data.customerViewDetails.customer_profile?.customer_add2 || ""}`,
                        City: customerData.data.customerViewDetails
                          .customer_profile?.city,
                        State:
                          customerData.data.customerViewDetails.customer_profile
                            ?.state,
                        pin: customerData.data.customerViewDetails
                          .customer_profile?.pin,
                        balance: customerData.data.customerBalance?.balance,
                        Status: customerData.data.customerViewDetails.is_active
                          ? "Active"
                          : "Inactive",
                      }).map(([key, value]) => (
                        <TableRow key={key}>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              fontSize: "0.8rem",
                              paddingY: "11px",
                            }}
                          >
                            {key}
                          </TableCell>
                          <TableCell
                            sx={{ fontSize: "0.8rem", paddingY: "11px" }}
                          >
                            {value || "N/A"}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Box>

            {/* Country Details Card */}
            <Card
              variant="outlined"
              sx={{
                borderRadius: 2,
                boxShadow: 2,
                bgcolor: "white",
                height: "100%",
                fontSize: "0.7rem",
              }}
            >
              <CardContent>
                {/* <Typography
                  variant="h6"
                  color="primary"
                  sx={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  Country Details
                </Typography> */}
                <List>
                  {countryDropdown.map((country) => {
                    const serviceName = country?.service?.service_name;

                    return (
                      <ListItem
                        key={country.customer_country_id}
                        sx={{ borderBottom: 1, borderColor: "divider", py: 1 }}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <Typography
                              sx={{ fontWeight: "bold", fontSize: "0.8rem" }}
                            >
                              Service: {serviceName}
                            </Typography>

                            <Typography
                              sx={{ fontWeight: "bold", fontSize: "0.8rem" }}
                            >
                              Country: {country?.country?.country_name}
                            </Typography>

                            <Typography sx={{ fontSize: "0.75rem" }}>
                              Code: {country?.country?.countrycode}
                            </Typography>

                            {/* ================= SMS ================= */}
                            {serviceName === "SMS" && (
                              <>
                                <Typography sx={{ fontSize: "0.75rem" }}>
                                  DLT Rate: {country.dlt_rates}
                                </Typography>
                                <Typography sx={{ fontSize: "0.75rem" }}>
                                  SMS Rate: {country.sms_rates}
                                </Typography>
                              </>
                            )}

                            {/* ================= RCS ================= */}
                            {serviceName === "RCS" && (
                              <>
                                <Typography sx={{ fontSize: "0.75rem" }}>
                                  RCS Media Rate: {country.rcs_media_rate}
                                </Typography>
                                <Typography sx={{ fontSize: "0.75rem" }}>
                                  RCS Text Rate: {country.rcs_text_rate}
                                </Typography>
                              </>
                            )}

                            {/* ================= WhatsApp ================= */}
                            {serviceName === "WhatsApp" && (
                              <>
                                <Typography sx={{ fontSize: "0.75rem" }}>
                                  Auth Price: {country.authentication_price}
                                </Typography>
                                <Typography sx={{ fontSize: "0.75rem" }}>
                                  Marketing Price: {country.marketing_price}
                                </Typography>
                                <Typography sx={{ fontSize: "0.75rem" }}>
                                  Utility Price: {country.utility_price}
                                </Typography>
                              </>
                            )}
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            sm={6}
                            display="flex"
                            justifyContent="flex-end"
                            alignItems="center"
                          >
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => handleEditCountryRates(country)}
                            >
                              Edit
                            </Button>
                          </Grid>
                        </Grid>
                      </ListItem>
                    );
                  })}
                </List>
              </CardContent>
            </Card>
          </div>

          {/* Rest of your modal code remains the same */}
          {isModalOpen && (
            <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
              <div className="bg-white p-4 rounded-lg shadow-lg w-[480px]">
                <form onSubmit={handleSubmitNewCountry} className="text-sm">
                  {/* Select Service */}
                  <div className="mb-2">
                    <label className="block font-medium mb-1">
                      Select Service
                    </label>
                    <select
                      className="w-full px-2 py-1 border border-gray-300 rounded-md text-sm"
                      value={selectedServiceId}
                      onChange={handleServiceChange}
                    >
                      <option value="">-- Select Service --</option>
                      {serviceData?.data?.map((service) => (
                        <option
                          key={service.service_id}
                          value={service.service_id}
                        >
                          {service.service_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Select Country */}
                  <div className="mb-2">
                    <label className="block font-medium mb-1">
                      Select Country
                    </label>
                    <select
                      className="w-full px-2 py-1 border border-gray-300 rounded-md text-sm"
                      onChange={handleCountrySelectForNewCountry}
                      disabled={!selectedServiceId}
                    >
                      <option value="">-- Select Country --</option>
                      {filteredCountries.map((item) => (
                        <option key={item.country_id} value={item.country_id}>
                          {item.country?.country_name || "N/A"}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* ================= SERVICE BASED FIELDS ================= */}

                  {/* SMS */}
                  {selectedService?.service_name === "SMS" && (
                    <>
                      <div className="mb-2">
                        <label className="block font-medium mb-1">
                          DLT Rates
                        </label>
                        <input
                          type="number"
                          name="dlt_rates"
                          defaultValue={resellerRates?.dlt_rates || ""}
                          className="w-full px-2 py-1 border rounded-md"
                          step="0.001"
                        />
                      </div>

                      <div className="mb-2">
                        <label className="block font-medium mb-1">
                          SMS Rates
                        </label>
                        <input
                          type="number"
                          name="sms_rates"
                          defaultValue={resellerRates?.sms_rates || ""}
                          className="w-full px-2 py-1 border rounded-md"
                          step="0.001"
                        />
                      </div>
                    </>
                  )}

                  {/* RCS */}
                  {selectedService?.service_name === "RCS" && (
                    <>
                      <div className="mb-2">
                        <label className="block font-medium mb-1">
                          RCS Media Rate
                        </label>
                        <input
                          type="number"
                          name="rcs_media_rate"
                          defaultValue={resellerRates?.rcs_media_rate || ""}
                          className="w-full px-2 py-1 border rounded-md"
                          step="0.001"
                        />
                      </div>

                      <div className="mb-2">
                        <label className="block font-medium mb-1">
                          RCS Text Rate
                        </label>
                        <input
                          type="number"
                          name="rcs_text_rate"
                          defaultValue={resellerRates?.rcs_text_rate || ""}
                          className="w-full px-2 py-1 border rounded-md"
                          step="0.001"
                        />
                      </div>
                    </>
                  )}

                  {/* WhatsApp */}
                  {selectedService?.service_name === "WhatsApp" && (
                    <>
                      <div className="mb-2">
                        <label className="block font-medium mb-1">AuthN</label>
                        <input
                          type="number"
                          name="auth_rate"
                          defaultValue={
                            resellerRates?.authentication_price || ""
                          }
                          className="w-full px-2 py-1 border rounded-md"
                          step="0.001"
                        />
                      </div>

                      <div className="mb-2">
                        <label className="block font-medium mb-1">
                          Marketing
                        </label>
                        <input
                          type="number"
                          name="marketing_rate"
                          defaultValue={resellerRates?.marketing_price || ""}
                          className="w-full px-2 py-1 border rounded-md"
                          step="0.001"
                        />
                      </div>

                      <div className="mb-2">
                        <label className="block font-medium mb-1">
                          Utility
                        </label>
                        <input
                          type="number"
                          name="utility_rate"
                          defaultValue={resellerRates?.utility_price || ""}
                          className="w-full px-2 py-1 border rounded-md"
                          step="0.001"
                        />
                      </div>
                    </>
                  )}

                  {/* Buttons */}
                  <div className="flex justify-end gap-2 mt-3">
                    <button
                      type="button"
                      onClick={handleModalClose}
                      className="bg-gray-500 text-white px-3 py-1.5 rounded-md text-[0.7rem]"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={isWhatsAppSelected && isPhoneFetching}
                      className="bg-blue-500 text-white px-3 py-1.5 rounded-md text-[0.7rem]"
                    >
                      Savess
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Other modals remain unchanged */}
          {balanceModalOpen && (
            <Dialog
              open={balanceModalOpen}
              onClose={handleBalanceModalClose}
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle sx={{ fontSize: "1rem" }}>Add Balance</DialogTitle>
              <DialogContent>
                <TextField
                  label="Balance"
                  type="number"
                  value={balance}
                  onChange={(e) => {
                    setBalance(e.target.value);
                    setBalanceError("");
                  }}
                  fullWidth
                  margin="normal"
                  size="small"
                  InputLabelProps={{ sx: { fontSize: "0.7rem" } }}
                  inputProps={{ style: { fontSize: "0.7rem" } }}
                />
                <TextField
                  label="Summary"
                  value={balanceSummary}
                  onChange={(e) => setBalanceSummary(e.target.value)}
                  fullWidth
                  margin="normal"
                  size="small"
                  InputLabelProps={{ sx: { fontSize: "0.7rem" } }}
                  inputProps={{ style: { fontSize: "0.7rem" } }}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleBalanceModalClose}
                  color="primary"
                  sx={{ fontSize: "0.7rem" }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleUpdateBalance}
                  color="primary"
                  variant="contained"
                  sx={{ fontSize: "0.7rem" }}
                >
                  Save
                </Button>
              </DialogActions>
            </Dialog>
          )}
          <Dialog
            open={openSettingsDialog}
            onClose={() => setOpenSettingsDialog(false)}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle
              sx={{
                backgroundColor: "#1565c0",
                color: "white",
                fontSize: "14px",
                fontWeight: 600,
                py: 0.8,
                px: 2,
              }}
            >
              Customer Settings
            </DialogTitle>
            <DialogContent sx={{ py: 2 }}>
              <Paper variant="outlined">
                <Table size="small">
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell sx={{ fontSize: "0.8rem", fontWeight: 600 }}>
                          {row.label}
                        </TableCell>
                        <TableCell sx={{ fontSize: "0.8rem" }}>
                          {row.value}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </DialogContent>

            <DialogActions sx={{ px: 2, py: 1 }}>
              <Button
                onClick={() => setOpenSettingsDialog(false)}
                variant="outlined"
                size="small"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
          {editingCustomer && (
            <EditCustomerModal
              customer={editingCustomer}
              updatedDetails={updatedDetails}
              setUpdatedDetails={setUpdatedDetails}
              handleFormSubmit={handleFormSubmit}
              handleCloseModal={handleCloseModal}
            />
          )}

          {countryRatesModalOpen && selectedCountryData && (
            <EditCountryRateModal
              country={selectedCountryData}
              handleCountryRateSubmit={handleCountryRateSubmit}
              handleCloseModal={handleCloseModal}
            />
          )}

          {makeResellerModalOpen && selectedCustomerData && (
            <MakeReseller
              isOpen={makeResellerModalOpen}
              onClose={handleCloseMakeResellerModal}
              customerData={selectedCustomerData}
            />
          )}

          {editTMDetailModalOpen && selectedCustomerData && (
            <EditTMDetail
              isOpen={editTMDetailModalOpen}
              onClose={handleCloseEditTMDetailModal}
              customerData={selectedCustomerData}
            />
          )}
        </main>
      </div>
    </div>
  );
};

export default ProfileDetail;
